export default {
    title: {
        default: 'ULTIMATE SERVICE'
    }
}
